import APIService from '../apiUtils';

export default class UserService {
  static async update(filter: any, updatedDoc: any): Promise<any> {
    return (
      await APIService.post('/graphql', {
        query: `mutation {
          updateUserEntity(filter: "${JSON.stringify(filter)}", updatedDoc: "${JSON.stringify(updatedDoc)}")
        }`,
      })
    ).data.updateUserEntity;
  }

  static async fetchUser(): Promise<any> {
    // return APIService.post<UserPayload>(ApiEndpoint.signIn, {
    //   email: reqBody.email,
    //   password: reqBody.password,
    // });
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ data: 'placeholder' }); // Yay! Everything went well!
      }, 250);
    });
  }

  static async updateUser(): Promise<any> {
    // return APIService.post<UserPayload>(ApiEndpoint.signIn, {
    //   email: reqBody.email,
    //   password: reqBody.password,
    // });
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ data: 'placeholder' }); // Yay! Everything went well!
      }, 1500);
    });
  }
}
